<template>
	<div class="day-block">
        <v-col>
            <v-row>
                <p class="px-8 day text weight-bold">{{ day }}</p>
            </v-row>
            <v-row 
                no-gutters
                class="input-row px-0"
            >
                <v-col cols="2">
                    <TextInput 
                        outlined
                        v-model="value.opening_hours"
                        inputType="time"
                        label="Ouvert de"
                        :value="value.opening_hours"
                        @input="(v) => update('opening_hours',v)"
                    />
                </v-col>
                <v-col cols="2">
                    <TextInput 
                        outlined
                        v-model="value.hour_break_start"
                        inputType="time"
                        label="Jusqu'a"
                        :value="value.hour_break_start"
                        @input="(v) => update('hour_break_start',v)"
                    /> 
                </v-col>
                <v-col justify="center" align="center" cols="4">
                    <div class="dayBreak text small text-grey-color">Pause de mi-journée</div>
                </v-col>
                <v-col cols="2">
                    <TextInput 
                        outlined
                        v-model="value.hour_break_end"
                        inputType="time"
                        label="Puis de"
                        :value="value.hour_break_end"
                        @input="(v) => update('hour_break_end',v)"
                    /> 
                </v-col>
                <v-col cols="2">
                    <TextInput 
                        outlined
                        v-model="value.closing_hours"
                        inputType="time"
                        label="Jusqu'a"
                        :value="value.closing_hours"
                        @input="(v) => update('closing_hours',v)"
                    /> 
                </v-col>
            </v-row>
            <v-row 
                no-gutters
                class="px-0"
            >
                <v-col
                    lg="2"
                    class="pa-0"
                >
                    <CheckBox 
                        label="Fermé"
                        v-model="value.is_open"
                        :value="value.is_open"
                        @input="(v) => update('is_open',v)"
                    />
                </v-col>
                <v-col
                    lg="5"
                >
                    <CheckBox 
                        label="Pause de mi-journée"
                        :value="value.midday_break"
                        v-model="value.midday_break"
                        @input="(v) => update('midday_break',v)"
                    />
                </v-col>
                <v-col lg="5">
                    <CheckBox 
                        label="Répéter tous les jours"
                        :v-model="allDays"
                    />
                </v-col>
            </v-row>
            <v-divider v-if="day !== 'Dimanche'"></v-divider>
        </v-col>
    </div>
</template>

<script type="text/javascript">
import CheckBox from '@/components/input/checkboxInput.vue'
import TextInput from '@/components/input/textInput.vue'

    export default {
        name: 'color-marker',
        components: {
            CheckBox,
            TextInput
        },
        props : {
            day: {
                type: String,
                default: '',
            },
            value: {
                type: Object,
                default: () => {
                    return {
                        day: null,
                        opening_hours : null,
                        hour_break_start : null,
                        hour_break_end : null,
                        closing_hours : null,
                        is_open: false,
                        midday_break: false
                    };
                }
            }
        },
        data () {
            return {
                allDays: '',
                checkbox: true,
            }
        },
        created() {
        },
        methods : {
            update(field, value) {
                this.$emit('input', {
                    day: this.day,
                    opening_hours: field === 'opening_hours' ? value : this.value.opening_hours,
                    hour_break_start: field === 'hour_break_start' ? value : this.value.hour_break_start,
                    hour_break_end: field === 'hour_break_end' ? value : this.value.hour_break_end,
                    closing_hours: field === 'closing_hours' ? value : this.value.closing_hours,
                    is_open: field === 'is_open' ? value : this.value.is_open,
                    midday_break: field === 'midday_break' ? value : this.value.midday_break,
                });
            }
        },
          computed: {
        },
    }

</script>

<style lang="scss">
    .day-block {
        input[type="time"]::-webkit-calendar-picker-indicator {
            background: none;
        }
        .input-row {
            display: flex;
            align-items: center;
        }
       .day {
           color: $color-primary;
           font-size: 17px;
       }
       .checkBox label {
           color: black;
       }
       .selectTimeInput {
           border: 2px solid $blue-light-border;
           border-radius: 5px;
           padding-left: 10px;
           padding-right: -50px;
           height: 50px;
       }
       .dayBreak {
           padding-top: 13%;
           text-align: center;
       }
    }
</style>